// * 공통 라우트

const cmmnRoutes = [
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    meta: {
      isDynamic: false,
    },
    component: () => import("@/views/common/ErrorPage.vue"),
  },
  {
    name: "error",
    path: "/error",
    meta: {
      isDynamic: false,
    },
    component: () => import("@/views/common/ErrorPage.vue"),
  },
  {
    name: "noServer",
    path: "/noServer",
    meta: {
      isDynamic: false,
    },
    component: () => import("@/views/common/NoPage.vue"),
  },
];

export default cmmnRoutes;
